import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: () => import('@/views/statistics/index.vue'),
        meta: { title: '统计' }
      },
      {
        path: 'permission/admin-user',
        name: 'AdminUser',
        component: () => import('@/views/permission/admin-user.vue'),
        meta: { title: '管理员' }
      },
      {
        path: 'permission/admin-role',
        name: 'AdminRole',
        component: () => import('@/views/permission/admin-role.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'permission/admin-menu',
        name: 'AdminMenu',
        component: () => import('@/views/permission/admin-menu.vue'),
        meta: { title: '菜单管理' }
      },
      {
        path: 'org/audit',
        name: 'OrgAudit',
        component: () => import('@/views/org/audit.vue'),
        meta: { title: '入驻审核' }
      },
      {
        path: 'org/tourism',
        name: 'OrgTourism',
        component: () => import('@/views/org/role.vue'),
        meta: { title: '文旅局', orgType: 'tourism' }
      },
      {
        path: 'org/education',
        name: 'OrgEducation',
        component: () => import('@/views/org/role.vue'),
        meta: { title: '教育局', orgType: 'education' }
      },
      {
        path: 'org/base',
        name: 'OrgBase',
        component: () => import('@/views/org/role.vue'),
        meta: { title: '研学基地', orgType: 'base' }
      },
      {
        path: 'org/base-detail',
        name: 'OrgBaseDetail',
        component: () => import('@/views/org/detail.vue'),
        meta: { title: '基地详情', menuPath: '/org/base', noTag: true }
      },
      {
        path: 'org/detail',
        name: 'OrgDetail',
        component: () => import('@/views/org/detail.vue'),
        meta: { title: '机构详情', noTag: true }
      },
      {
        path: 'org/activities',
        name: 'OrgActivities',
        component: () => import('@/views/org/activities.vue'),
        meta: { title: '活动订单', noTag: true, menuPaths: ['/org/base', '/org/school', '/org/transport', '/org/hotel', '/org/restaurant', '/org/tourism', '/org/education'] }
      },
      {
        path: 'org/base-edit',
        name: 'OrgBaseEdit',
        component: () => import('@/views/org/base-edit.vue'),
        meta: { title: '修改基地资料', menuPath: '/org/base', noTag: true }
      },
      {
        path: 'org/edit',
        name: 'OrgEdit',
        component: () => import('@/views/org/edit.vue'),
        meta: { title: '修改机构资料', noTag: true, menuPaths: ['/org/tourism', '/org/education', '/org/school', '/org/transport', '/org/hotel', '/org/restaurant'] }
      },
      {
        path: 'org/school',
        name: 'OrgSchool',
        component: () => import('@/views/org/role.vue'),
        meta: { title: '学校', orgType: 'school' }
      },
      {
        path: 'org/transport',
        name: 'OrgTransport',
        component: () => import('@/views/org/role.vue'),
        meta: { title: '运输机构', orgType: 'transport' }
      },
      {
        path: 'org/hotel',
        name: 'OrgHotel',
        component: () => import('@/views/org/role.vue'),
        meta: { title: '酒店', orgType: 'hotel' }
      },
      {
        path: 'org/restaurant',
        name: 'OrgRestaurant',
        component: () => import('@/views/org/role.vue'),
        meta: { title: '餐饮', orgType: 'restaurant' }
      },
      // 兼容旧菜单路径
      {
        path: 'org/list',
        redirect: '/org/base'
      },
      {
        path: 'org/regulator',
        redirect: '/org/tourism'
      },
      {
        path: 'course/audit',
        name: 'CourseAudit',
        component: () => import('@/views/course/audit.vue'),
        meta: { title: '课程审核' }
      },
      {
        path: 'course/list',
        name: 'CourseList',
        component: () => import('@/views/course/list.vue'),
        meta: { title: '课程列表' }
      },
      {
        path: 'course/detail',
        name: 'CourseDetail',
        component: () => import('@/views/course/detail.vue'),
        meta: { title: '课程详情', noTag: true }
      },
      {
        path: 'course/edit',
        name: 'CourseEdit',
        component: () => import('@/views/course/edit.vue'),
        meta: { title: '修改课程', noTag: true }
      },
      {
        path: 'activity/audit',
        name: 'ActivityAudit',
        component: () => import('@/views/activity/audit.vue'),
        meta: { title: '活动审核' }
      },
      {
        path: 'activity/list',
        name: 'ActivityList',
        component: () => import('@/views/activity/list.vue'),
        meta: { title: '活动列表' }
      },
      {
        path: 'activity/enrolling',
        name: 'ActivityEnrolling',
        component: () => import('@/views/activity/list.vue'),
        meta: { title: '报名中', menuPath: '/activity/enrolling', phase: 'j8' }
      },
      {
        path: 'activity/running',
        name: 'ActivityRunning',
        component: () => import('@/views/activity/list.vue'),
        meta: { title: '进行中', menuPath: '/activity/running', phase: 'j2' }
      },
      {
        path: 'activity/settling',
        name: 'ActivitySettling',
        component: () => import('@/views/activity/list.vue'),
        meta: { title: '待结算', menuPath: '/activity/settling', phase: 'j4' }
      },
      {
        path: 'activity/completed',
        name: 'ActivityCompleted',
        component: () => import('@/views/activity/list.vue'),
        meta: { title: '已完成', menuPath: '/activity/completed', phase: 'j5' }
      },
      {
        path: 'activity/detail',
        name: 'ActivityDetail',
        component: () => import('@/views/activity/detail.vue'),
        meta: { title: '活动详情', noTag: true, menuPaths: ['/activity/list', '/activity/audit', '/activity/enrolling', '/activity/running', '/activity/settling', '/activity/completed', '/org/activities'] }
      },
      {
        path: 'enroll/list',
        name: 'EnrollList',
        component: () => import('@/views/enroll/list.vue'),
        meta: { title: '报名管理' }
      },
      {
        path: 'enroll/insurance',
        name: 'InsuranceList',
        component: () => import('@/views/enroll/insurance.vue'),
        meta: { title: '保单列表' }
      },
      {
        path: 'ops/complaint',
        name: 'Complaint',
        component: () => import('@/views/ops/complaint.vue'),
        meta: { title: '投诉工单' }
      },
      {
        path: 'ops/fans',
        name: 'OpsFans',
        component: () => import('@/views/ops/fans.vue'),
        meta: { title: '粉丝管理' }
      },
      {
        path: 'ops/evaluation',
        name: 'Evaluation',
        component: () => import('@/views/ops/evaluation.vue'),
        meta: { title: '评价管理' }
      },
      {
        path: 'ops/certificate',
        name: 'Certificate',
        component: () => import('@/views/ops/certificate.vue'),
        meta: { title: '证书管理' }
      },
      {
        path: 'ops/points',
        name: 'PointLog',
        component: () => import('@/views/ops/points.vue'),
        meta: { title: '积分流水' }
      },
      {
        path: 'ops/fund',
        name: 'Fund',
        component: () => import('@/views/ops/fund.vue'),
        meta: { title: '资金流水' }
      },
      {
        path: 'ops/location',
        name: 'Location',
        component: () => import('@/views/ops/location.vue'),
        meta: { title: '定位占位' }
      },
      {
        path: 'mini-user',
        name: 'MiniUser',
        component: () => import('@/views/mini/user.vue'),
        meta: { title: '小程序用户', menuPath: '/mini-user' }
      },
      {
        path: 'log/admin',
        name: 'AdminLog',
        component: () => import('@/views/log/admin.vue'),
        meta: { title: '后台日志', menuPath: '/log/admin' }
      },
      {
        path: 'log/mini',
        name: 'MiniLog',
        component: () => import('@/views/log/mini.vue'),
        meta: { title: '用户端日志', menuPath: '/log/mini' }
      },
      {
        path: 'log/store',
        name: 'StoreLog',
        component: () => import('@/views/log/store.vue'),
        meta: { title: '机构后台日志', menuPath: '/log/store' }
      },
      {
        path: 'system/config',
        name: 'SystemConfig',
        component: () => import('@/views/system/config.vue'),
        meta: { title: '基础设置' }
      },
      {
        path: 'system/upload',
        name: 'SystemUpload',
        component: () => import('@/views/system/upload.vue'),
        meta: { title: '上传设置' }
      },
      {
        path: 'system/sms',
        name: 'SystemSms',
        component: () => import('@/views/system/sms.vue'),
        meta: { title: '短信配置' }
      },
      {
        path: 'system/notify',
        name: 'SystemNotify',
        component: () => import('@/views/system/notify.vue'),
        meta: { title: '通知消息' }
      },
      {
        path: 'cms/news',
        name: 'CmsNews',
        component: () => import('@/views/cms/news.vue'),
        meta: { title: '新闻资讯', menuPath: '/cms/news' }
      },
      {
        path: 'fence/monitor',
        name: 'FenceMonitor',
        component: () => import('@/views/fence/monitor.vue'),
        meta: { title: '监控', menuPath: '/fence/monitor', darkLayout: true }
      }
    ]
  },
  { path: '*', redirect: '/dashboard', hidden: true }
]

const createRouter = () =>
  new Router({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()
export default router
